import { render, staticRenderFns } from "./KnowDialog.vue?vue&type=template&id=0f157396&scoped=true"
import script from "./KnowDialog.vue?vue&type=script&lang=js"
export * from "./KnowDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f157396",
  null
  
)

export default component.exports